<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
            <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
                <template slot="no-body">

                    <!-- ITEM IMAGE -->
                    <div class="item-img-container bg-white  flex items-center justify-center mb-4 cursor-pointer" @click="navigate_to_detail_view">
                        <img :src="item.imagen?('data:image/png;base64,'+item.imagen+''):defaultImageURL" :alt="item.nomart" class="grid-view-img">
                    </div>
                    <div class="item-details px-4">

                        <!-- CODART -->
                        <div class="my-4">
                            <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.nomart }}</h6>
                            <div class="flex justify-between items-center">
                                <h6>{{ item.codart }}</h6>
                                <div class="text-primary border border-solid border-primary flex py-1 px-2 rounded">
                                    <span class="text-sm mr-1 font-bold">${{ lispreShow() }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- SLOT: ACTION BUTTONS -->
                    <slot name="action-buttons" />
                </template>
            </vx-card>
       <!--  </div>
    </div> -->
</template>

<script>
import {mapState} from 'vuex'

export default{
  data () {
    return {
        defaultImageURL: require('@/assets/images/elements/not-available-es.png')
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState('eCommerce',['lispreState']),
  },
  methods: {
    lispreShow (){
        var lis = this.lispreState;
        if(lis.toString() === '1'){
            return this.item.prec01
        }else if (lis.toString() === '2'){
            return this.item.prec02
        }else if(lis.toString() === '3'){
            return this.item.prec03
        }else if (lis.toString() === '4'){
            return this.item.prec04
        }else{
            return this.item.prec01
        }
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'ecommerce-item-detail-view', params: {item_id: this.item.codart }})
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        // width: auto;
        transition: .35s;
        object-fit: cover;
        width: 100%;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
